module.exports = __webpack_public_path__ + "static/media/motivation.6bad8d47.png";